export enum DestinationVendange {
    CC = 'Cave coopérative',
    CP = 'Cave particulière',
    NEG = 'Négociant'
}
